<template>
  <form autocomplete="off">
    <div class="mb-4">
      <span class="body-1 mb-4">Datos personales</span>
    </div>

    <v-text-field
      v-model="practitioner.name"
      label="Nombre completo"
      outlined
      required
    ></v-text-field>
    <v-text-field
      v-model="practitioner.phone"
      prefix="+56"
      required
      label="Teléfono"
      type="number"
      outlined
      :rules="[
        () => !!practitioner.phone || 'Campo requerido',
        () => isValidPhone || 'Formato requerido'
      ]"
    ></v-text-field>
    <v-text-field
      v-model="practitioner.email"
      label="Email"
      type="email"
      outlined
      required
      :rules="[() => !!practitioner.email || 'Campo requerido']"
    ></v-text-field>

    <v-divider class="mb-4"></v-divider>

    <div class="mb-4">
      <span class="body-1">Configuración cuenta</span>
    </div>

    <v-text-field
      v-model="practitioner.password"
      label="Contraseña"
      type="password"
      outlined
      :rules="[() => !!practitioner.password || 'Campo requerido']"
    ></v-text-field>

    <v-text-field
      v-model="practitioner.passwordConfirmed"
      label="Repita contraseña"
      type="password"
      outlined
      :rules="[
        () => !!practitioner.password || 'Campo requerido',
        () =>
          practitioner.password == practitioner.passwordConfirmed ||
          'Contraseñas no coinciden'
      ]"
    ></v-text-field>

    <v-checkbox
      label="Acepto los términos y condiciones"
      class="mb-2"
    ></v-checkbox>
  </form>
</template>

<script>
export default {
  props: ["practitioner"],
  data: () => ({
    genderList: ["Masculino", "Femenino", "Prefiere no decir"]
  }),
  computed: {
    isValidPhone() {
      let { phone = "" } = this.practitioner;
      return !isNaN(phone) && phone.length == 9;
    }
  }
};
</script>

<style></style>
